import contact from 'src/i18n/en/validations/contact';
import login from 'src/i18n/en/validations/login';
import invoice from 'src/i18n/en/validations/invoice';
import creditcard from 'src/i18n/en/validations/creditcard';
import organisation from 'src/i18n/en/validations/organisation';
import fundraising from 'src/i18n/en/validations/fundraising';
import ticket from 'src/i18n/en/validations/ticket';

const validations = {
  contact,
  creditcard,
  fundraising,
  invoice,
  login,
  organisation,
  ticket,
};

export default validations;
